export class UpploadEffect {
    constructor() {
        this.type = "effect";
        this.name = "";
        this.invisible = false;
        this.noRecolor = false;
        this.color = "#000";
        this.icon = "";
        this.template = () => "";
        this.handlers = () => { };
        this.supports = () => true;
    }
}
//# sourceMappingURL=effect.js.map